export enum AddressOwnerType {
  Customer = 'Customer',
  Store = 'Store',
  Silal = 'Silal',
}

export interface Address {
  nick_name?: string;
  customer_id: number;
  owner_type: string;
  id: number;
  lat: string;
  lng: string;
  address_line_1: string;
  address_line_2: string;
  notes: string;
  town: Town;
  city: City;
  locked: boolean;
  hidden: boolean;
  display_name: string;
  phone_number: string;
}
export interface City {
  name_en: string;
  name_ar: string;
  id: number;
  lat: string;
  lng: string;
  region: number;
  delivery_fee: number;
  cross_order_delivery_fee_discount: number;
}
export interface Town {
  name_en: string;
  name_ar: string;
  id: number;
  lat: string;
  lng: string;
  city_id: number;
}
